/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, SimpleChanges, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import * as _ from 'lodash';
import template from './external-demand-source-analysis-page.component.html';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {APP_SHARED} from '../../common/app-shared';
import {CHARTS} from '../../common/directives/charts';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule, ...CHARTS],
  selector: 'adn-external-demand-source-analysis-page',
  template
})
export class ExternalDemandSourceAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() isNew: boolean;

  effectiveIsNew = false;
  canSeeReports = false;
  isPrebid = true;
  bidders = signal<Array<{bidder: string; biddersHook: any}>>([]);
  allBidders = '';
  statsData = signal<any>(null);
  selBidder = signal<string | null>(null);
  oneFieldHook: any = {};
  biddersHook: any;

  constructor(@Inject(LocalUserPermissions) LocalUserPermissions: any) {
    this.canSeeReports = LocalUserPermissions.getAnyVisibility().RUN_REPORTS === true;
    this.biddersHook = this.createBiddersHook();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
    if (changes.model || changes.isNew) {
      this.resetForModel();
    }
  }

  trackByBidder(_index: number, bidder: {bidder: string}): string {
    return bidder.bidder;
  }

  private createBiddersHook(): any {
    return {
      onBiddersFound: (bidders: string[], stats: any) => {
        if (!_.isArray(bidders) || bidders.length === 0) {
          return;
        }
        this.bidders.set(_.map(bidders, (bidder) => ({
          bidder,
          biddersHook: {}
        })));
        this.biddersHook.biddersRegistered = true;
        this.allBidders = bidders.join(', ');
        this.statsData.set(stats);
        this.selBidder.set(this.bidders()[0].bidder);
        this.oneFieldHook = {};
      },
      onSelections: (stats: any, dateOption: any, startDate: any, endDate: any, countType: any, yAxisOption: any, selFieldIds: any, selFieldId: any) => {
        // Keep parent stats in sync so *ngIf-mounted and later-selected bidder charts
        // pick up date/field changes via [statsData], not only via reboot.
        this.statsData.set(stats);
        _.forEach(this.bidders(), (bidderEntry) => {
          if (!_.isFunction(_.get(bidderEntry, 'biddersHook.reboot'))) {
            return;
          }
          bidderEntry.biddersHook.reboot(stats, dateOption, startDate, endDate, countType, yAxisOption, selFieldIds, selFieldId);
        });
        if (_.isFunction(_.get(this.oneFieldHook, 'reboot'))) {
          this.oneFieldHook.reboot(stats, dateOption, startDate, endDate, countType, yAxisOption, selFieldIds, selFieldId);
        }
      }
    };
  }

  private resetForModel(): void {
    this.isPrebid = this.model?.externalPartner === 'PREBID_JS';
    this.bidders.set([]);
    this.allBidders = '';
    this.statsData.set(null);
    this.selBidder.set(null);
    this.oneFieldHook = {};
    this.biddersHook = this.createBiddersHook();
  }

}
